
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit-authorization-agreement",
      function () {
        return require("private-next-pages/credit-authorization-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit-authorization-agreement"])
      });
    }
  